import type { UserType } from "$/lib/types/models/User.types";
import { restApiClient } from "$/lib/utils/restApiClient";

export async function getMeApi(year: number = new Date().getFullYear()) {
  return restApiClient.get<UserType>("/auth/me", {
    query: {
      year,
    },
  });
}
